import { useState } from 'react'
import { useAuth } from '../auth'
import { Note } from '../components/ui'

export default function Login() {
  const { login, loginError, loggingIn } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  return (
    <div className="login-page">
      <form
        className="card login-card"
        onSubmit={(e) => {
          e.preventDefault()
          void login(email, password).catch(() => {
            /* surfaced through loginError */
          })
        }}
      >
        <div className="body">
          <h1>Finance Platform</h1>
          <p className="lede">Sign in to continue.</p>
          {loginError && <Note kind="error">{loginError}</Note>}
          <label>
            <span className="caption">Email</span>
            <input
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>
          <label>
            <span className="caption">Password</span>
            <input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </label>
          <button className="primary" type="submit" disabled={loggingIn} style={{ width: '100%' }}>
            {loggingIn ? 'Signing in…' : 'Sign in'}
          </button>
        </div>
      </form>
    </div>
  )
}
